import React from 'react';
import { motion } from 'framer-motion';

export const WhatsAppWidget = () => {
    return (
        <motion.a
            href="https://wa.me/918089713733"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="fixed bottom-28 right-6 z-50 bg-[#25D366] text-white p-2.5 rounded-full shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center cursor-pointer"
            aria-label="Chat on WhatsApp"
        >
            <svg
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor"
            >
                <path d="M12.004 0C5.378 0 0 5.378 0 12c0 2.128.555 4.12 1.54 5.86L.006 24l6.305-1.652a11.9 11.9 0 0 0 5.693 1.442h.005c6.627 0 12-5.378 12-12S18.63 0 12.004 0zm0 21.785h-.005a9.851 9.851 0 0 1-5.01-1.364l-.36-.214-3.73.977.994-3.638-.235-.374A9.852 9.852 0 0 1 2.15 12c0-5.438 4.425-9.86 9.864-9.86 2.636 0 5.115 1.026 6.98 2.89 1.861 1.865 2.887 4.343 2.887 6.974 0 5.436-4.425 9.86-9.86 9.86l-.015-.08zM17.41 14.4c-.296-.148-1.754-.866-2.025-.965-.27-.1-.468-.148-.665.148-.198.297-.768.966-.94 1.164-.173.198-.347.223-.643.074-.297-.148-1.25-.46-2.383-1.47-1.045-.93-1.75-2.077-1.947-2.375-.198-.297-.02-.458.128-.606.134-.134.296-.346.445-.52.148-.173.197-.296.296-.495.099-.197.05-.37-.024-.52-.074-.147-.665-1.603-.91-2.19-.24-.575-.484-.497-.665-.506-.174-.01-.37-.01-.568-.01-.197 0-.52.074-.79.37-.27.297-1.037 1.015-1.037 2.472s1.06 2.868 1.21 3.065c.148.198 2.086 3.187 5.05 4.467 2.03.874 2.805.9 3.826.758.91 0 2.673-1.09 3.045-2.14.37-1.05.37-1.954.26-2.14-.112-.187-.41-.298-.707-.446z" />
            </svg>
        </motion.a>
    );
};
